'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/9/12.
                    */

// import ReactDOM from 'react-dom';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyWallet = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MyWallet, _Component);

  function MyWallet() {
    (0, _classCallCheck3.default)(this, MyWallet);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MyWallet).apply(this, arguments));
  }

  (0, _createClass3.default)(MyWallet, [{
    key: 'render',


    /*
    componentDidUpdate() {
      ReactDOM.findDOMNode(this).scrollIntoView();
    } */

    value: function render() {
      var location = this.props.location;

      var headArray = [{
        text: '我的佣金',
        url: '/personalcenter/mywallet/mycommissions',
        img: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/icont17.png'
      }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.GoeasyTabBar, { data: headArray, activePath: location.pathname }),
        this.props.children
      );
    }
  }]);
  return MyWallet;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp);
exports.default = MyWallet;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MyWallet/MyWallet.js
 ** module id = 1501
 ** module chunks = 0
 **/